import { useMemo } from "react";

import Help from "chameleon/icons/help";

import { Tooltip, TooltipProps } from "../tooltip/tooltip";
import {
  largeContentStyle,
  mediumContentStyle,
  smallContentStyle,
  tooltipWrapper,
} from "./help-tooltip.css";

const HelpTooltip = ({
  content = "",
  position = "top",
  size = "small",
  tooltipAriaLabel,
}: {
  content: string | undefined;
  position?: TooltipProps["tooltipPosition"];
  size?: "small" | "medium" | "large";
  tooltipAriaLabel?: string;
}) => {
  const contentClass = useMemo(() => {
    switch (size) {
      case "small":
        return smallContentStyle;
      case "medium":
        return mediumContentStyle;
      case "large":
        return largeContentStyle;
    }
  }, [size]);

  return (
    <div className={tooltipWrapper}>
      <Tooltip
        content={<div className={contentClass}>{content}</div>}
        tooltipPosition={position}
        ariaLabel={tooltipAriaLabel}
      >
        <Help role={"presentation"} aria-hidden={"true"} />
      </Tooltip>
    </div>
  );
};

export default HelpTooltip;
